import Alpine from "alpinejs";
import Swiper from "swiper";
import { Pagination } from "swiper/modules";

Alpine.data('KeyDatesSwiper', () => ({
    init(){
        const swiper = new Swiper(this.$el.querySelector('.keyDatesSwiper'), {
            modules: [Pagination],
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 16,
            pagination: {
                el: this.$el.querySelector('.swiper-pagination'),
                bulletActiveClass: 'opacity-100',
                clickable: true,
                renderBullet: function(index, className){
                    return '<span class="w-2 h-2 opacity-30 block rounded-full bg-primary-dark ' + className + '"></span>';
                }
            },
            breakpoints: {
                768: {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                }
            }
        })
    }
}));